const getBrowser = () => {
  const is = {};
  try {
    // Opera 8.0+
    // eslint-disable-next-line
    is.opera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    // eslint-disable-next-line
    is.firefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]"
    // eslint-disable-next-line
    is.safari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

    // Internet Explorer 6-11
    // eslint-disable-next-line
    is.ie = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    // eslint-disable-next-line
    is.edge = !is.ie && !!window.StyleMedia;

    // Chrome 1+
    // eslint-disable-next-line
    is.chrome = !!window.chrome

    // Blink engine detection
    // eslint-disable-next-line
    is.blink = (is.chrome || is.opera) && !!window.CSS;
  } catch (e) {
    console.error('Encountered an exception while detecting browser:', e);
  }

  console.log(is);
  const obj = Object.entries(is).find(([, value]) => value);
  return obj && obj[0];
};

export default getBrowser;
